import React from "react";
import { Music, MessageSquare, X } from "lucide-react";
import { motion } from "framer-motion";

const NotificationBanner = ({
  showNotification,
  notificationData,
  notificationType,
  setShowNotification,
}) => {
  if (!showNotification || !notificationData) return null;

  return (
    <motion.div
      key="notification"
      className="fixed top-4 right-4 z-[9999] w-full max-w-xs sm:max-w-sm"
      initial={{ opacity: 0, x: 300, scale: 0.8 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 300, scale: 0.8 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      {notificationType === "song" ? (
        <div className="bg-gradient-to-r from-purple-900 md:block hidden to-indigo-800 text-white rounded-2xl p-4 shadow-2xl border border-purple-300/30 backdrop-blur-sm">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 relative">
              <img
                src={notificationData.image}
                alt={notificationData.title}
                className="w-16 h-16 rounded-lg object-cover shadow-lg border-2 border-white/20"
              />
              <div className="absolute -bottom-1 -right-1 bg-logo rounded-full p-1">
                <Music className="w-4 h-4 text-white" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-start">
                <h3 className="font-bold text-white text-sm sm:text-base truncate">
                  New Song Request!
                </h3>
                <button
                  onClick={() => setShowNotification(false)}
                  className="p-1 hover:bg-white/10 rounded-full"
                >
                  <X className="w-4 h-4 text-white" />
                </button>
              </div>
              <div className="mt-1">
                <p className="font-medium text-sm truncate">
                  {notificationData.title}
                </p>
                {notificationData.artist && (
                  <p className="text-xs text-purple-200 truncate">
                    by {notificationData.artist}
                  </p>
                )}
              </div>
              <div className="mt-2 flex items-center gap-2">
                <div className="w-6 h-6 rounded-full overflow-hidden border border-white/30">
                  <img
                    src={notificationData.userPhoto}
                    alt={notificationData.requestedBy}
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="text-xs text-purple-100">
                  {notificationData.requestedBy}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-gradient-to-r from-red-900 to-pink-800 text-white rounded-2xl p-4 shadow-2xl border border-red-300/30 backdrop-blur-sm">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-red-800/50 rounded-lg flex items-center justify-center border-2 border-white/20">
                <MessageSquare className="w-8 h-8 text-white" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between items-start">
                <h3 className="font-bold text-white text-sm sm:text-base">
                  New Shoutout!
                </h3>
                <button
                  onClick={() => setShowNotification(false)}
                  className="p-1 hover:bg-white/10 rounded-full"
                >
                  <X className="w-4 h-4 text-white" />
                </button>
              </div>
              <div className="mt-1">
                <p className="font-medium text-sm line-clamp-2">
                  {notificationData.message}
                </p>
                {notificationData.track && (
                  <div className="mt-2 flex items-center gap-2 bg-white/10 p-2 rounded-lg">
                    <img
                      src={notificationData.track.album.images[0].url}
                      alt={notificationData.track.name}
                      className="w-8 h-8 rounded-md"
                    />
                    <div className="min-w-0">
                      <p className="text-xs font-medium truncate">
                        {notificationData.track.name}
                      </p>
                      <p className="text-xs text-red-200 truncate">
                        {notificationData.track.artists
                          .map((a) => a.name)
                          .join(", ")}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default NotificationBanner;
